import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const get_notification_list = async (
  type = "unread",
  page = 0,
  limit = 20
) => {
  const requestObj = {
    path: `api/notification/list_notifications?type=${type}&page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const read_notification = async (id) => {
  const requestObj = {
    path: `api/notification/read_notification/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const read_all_notification = async () => {
  const requestObj = {
    path: `api/notification/read_all_notification`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
